var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{staticClass:"portal-ai"},[_c('Banner'),_vm._v(" "),_c('LmIntro'),_vm._v(" "),_c('LmApplicationEngine'),_vm._v(" "),_c('LmLoopClose')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663d9f5d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/fastclass-loader!./src/components/PortalLM.vue
// module id = null
// module chunks = 